import { fadeOutNotifications } from '../functions';


$(document).ready(function() {

    $(document).on('click', '#apply-coupon', function(e) {
        e.preventDefault();

		//$('#cart-page-notifications').html('');
        $('#coupon-code').removeClass('is-invalid');

		if($('#coupon-code').val() == '') {
            $('#coupon-code').addClass('is-invalid');
            return false;
        }

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");
        values += '&code=' + $('#coupon-code').val();
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/apply-coupon",
            data: values,
            success: function(response) {
                if (response.status == 0) {
					$('#coupon-code').val('');
					Swal.fire({
						//icon: "success",
						// title: "Eroare!",
						html: response.message
					});
					// $('#cart-page-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
					// fadeOutNotifications('#cart-page-notifications .errors-wrapper');
                    return false;
                }

                if (response.status == 1) {
					$('#coupon-code').attr('readonly', 'readonly');
					$('#apply-coupon').text($('#apply-coupon').data('text-remove'));
					$('#apply-coupon').attr('id', 'remove-coupon');

					Swal.fire({
						//icon: "success",
						// title: "Success!",
						html: response.message
					});
					// $('#cart-page-notifications').html('<div class="success-wrapper"><p>'+response.message+'</p></div>');
					// fadeOutNotifications('#cart-page-notifications .success-wrapper');

					let html = `<hr class="mt-0">
					<div class="card-extra mb-2 d-flex align-items-center justify-content-between">
						<h6 class="mb-0">Cod discount <b>${response.coupon.code}</b></h6>
						<span class="points-summary-amount">-${response.coupon.discount_value}${response.coupon.discount_symbol}</span>
					</div>`;
					$('.coupon-wrapper').html(html);



					$('.shoppingcart-main-total').text(response.total + ' LEI');
					$('.order-total').text(response.total + ' LEI');

                    return false;
                }

				$('#coupon-code').val('');
				Swal.fire({
					//icon: "success",
					// title: "Eroare!",
					html: response.message
				});
				// $('#cart-page-notifications').html('<div class="errors-wrapper"><p>'+response.message+'</p></div>');
				// fadeOutNotifications('#cart-page-notifications .errors-wrapper');
				return false;
            },
            error(error) {

            }
        });
    });

	$(document).on('click', '#remove-coupon', function(e) {
        e.preventDefault();

		var values = '_token=' + $("meta[name='csrf-token']").attr("content");
		$.ajax({
            type: "POST",
            url: baseURL + "/cart/remove-coupon",
            data: values,
            success: function(response) {

                if (response.status == 1) {

					$('.coupon-wrapper').html('');
					$('#coupon-code').val('');
					$('#coupon-code').removeAttr('readonly');
					$('#remove-coupon').text($('#remove-coupon').data('text-apply'));
					$('#remove-coupon').attr('id', 'apply-coupon');

					$('.shoppingcart-main-total').text(response.total + ' LEI');
					$('.order-total').text(response.total + ' LEI');

                    return false;
                }

				Swal.fire({
					//icon: "success",
					title: "Eroare!",
					html: response.message
				});
				// $('#cart-page-notifications').html('<div class="errors-wrapper"><p>Error: Something went wrong please contact an administrator!</p></div>');
				// fadeOutNotifications('#cart-page-notifications .errors-wrapper');
				return false;
            },
            error(error) {

            }
        });
	});
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/coupons.js